<template>
  <div>
      <v-icon size="180" color="teal accent-3">fas fa-check-circle</v-icon>
      <h1 class="headline font-weight-medium grey--text my-2">Recuperação de senha realizada com sucesso!</h1>
      <h1
        class="text-center subtitle-1 font-weight-medium grey--text my-2"
      >Agora, faça o login para acessar a sua conta novamente</h1>
      <v-container>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-btn
            class="body-2 white--text"
            color="primary"
            width="120"
            height="45"
            depressed
            to="/"
          >Login</v-btn>
          <v-spacer></v-spacer>
        </v-layout>
      </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>